import { DocumentTemplate } from './../model/document-template';
import { TaskDetails } from '../model/task-details';
import { Task } from '../model/task';
import { Identity } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaskAdministrationService {

  constructor(private httpService: HttpService) { }

  public getTasks(): Observable<Task[]> {
    return this.httpService.postWithContext<Task[]>(environment.taskAdmininEndpoint, {});
  }

  public getDocuments(): Observable<DocumentTemplate[]> {
    return this.httpService.postWithContext<DocumentTemplate[]>(environment.taskAdmininEndpoint + '/documents', {});
  }

  public getTaskDetails(identity: Identity): Observable<TaskDetails> {
    return this.httpService.postWithContext<TaskDetails>(environment.taskAdmininEndpoint + '/details', identity);
  }

  public saveTask(details: TaskDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.taskAdmininEndpoint + '/save', details);
  }

  public createTask(details: TaskDetails): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.taskAdmininEndpoint + '/create', details);
  }

  public deleteTask(identity: Identity): Observable<ServiceResponse> {
    return this.httpService.postWithContext<ServiceResponse>(environment.taskAdmininEndpoint + '/delete', identity);
  }
}
